import React from "react";
var __jsx = React.createElement;
function AcceptedIcon() {
  return /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "113",
    height: "96",
    viewBox: "0 0 113 96",
    fill: "none"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path",
    opacity: "0.4",
    d: "M112.676 39.0987V56.1691C112.676 84.6197 101.408 96 73.2393 96H39.4365C11.2676 96 0 84.6197 0 56.1691V39.0987C0 15.2112 7.94364 3.38027 27.1549 0.169014H28.1689L84.5068 0C104.45 2.92957 112.676 14.8169 112.676 39.0987Z",
    fill: "#D5FBE4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    d: "M78.3412 29.93L48.51 59.8891L35.2128 46.5751C32.7878 44.1466 28.8487 44.1403 26.4152 46.559C23.9811 48.9783 23.9741 52.9082 26.399 55.3361L42.1682 71.1251C43.8609 72.8215 46.1143 73.7561 48.5137 73.7561H48.5191C50.9197 73.7545 53.174 72.8175 54.8655 71.1187L87.1677 38.6779C89.589 36.2464 89.5759 32.3164 87.1388 29.9008C84.701 27.4854 80.7625 27.4979 78.3412 29.93Z",
    fill: "#00B362"
  })));
}
export default AcceptedIcon;